import styled from '@emotion/styled';
import React from 'react';
import { spacing, colors, breakpoints } from '../../utils/styleguide';
import Typography from './text/Typography';

const ContentWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  ${breakpoints.tablet} {
    align-items: flex-start;
  }
`;

const Prompt = styled(Typography)`
  width: 100%;
  text-align: center;
  margin: ${spacing[1]}px 0 0;
`;

type ButtonPromptWrapperProps = {
  children?: React.ReactNode;
  className?: string;
  prompt?: string;
  variant?: 'light' | 'dark';
};

const ButtonPromptWrapper = ({
  children,
  className,
  prompt,
  variant = 'light',
}: ButtonPromptWrapperProps) => {
  return (
    <ContentWrapper className={className}>
      {children}
      {prompt && (
        <Prompt variant="smallText" color={variant === 'dark' ? colors.white : colors.darkGray}>
          {prompt}
        </Prompt>
      )}
    </ContentWrapper>
  );
};

export default ButtonPromptWrapper;
